import React from "react";
import withRouter from "../../../withRouter";
import BasePage from "../../../base/BasePage";
import Progress from "../../../components/Progress";
import CardView from "../../../components/common/CardView";
import RegionTab from "../../../components/common/RegionTab";
import LeaveCredits from "../Employees/forms/employment/tables/LeaveCredits";
import LeaveCard from "../Employees/forms/employment/tables/LeaveCard";
import { findObjectUseCase } from "../../../usecases/object";

class LeaveCreditsFormPage extends BasePage {
  constructor(props) {
    super(props);
    this.state = {
      object: null,
      loading: true,
    };
  }

  async componentDidMount() {
    const id = this.props.params?.id;
    if (!id) {
      this.setState({ loading: false });
      return;
    }

    try {
      const employees = await findObjectUseCase().execute("employees", {
        where: { id },
      });
      this.setState({ object: employees[0] || null, loading: false });
    } catch (error) {
      this.setState({ loading: false });
      this.showError(error);
    }
  }

  onClickBack() {
    this.navigateTo("/leave_credits");
  }

  render() {
    const { object, loading } = this.state;

    if (loading) return <Progress />;

    if (!object) {
      return (
        <div className="p-5" style={{ marginTop: "5rem" }}>
          <p>Employee not found.</p>
          <button
            type="button"
            className="btn btn-primary"
            onClick={this.onClickBack.bind(this)}
          >
            Back
          </button>
        </div>
      );
    }

    const employeeName = `${object.surname || ""}, ${object.Firstname || ""} ${
      object.Middlename || ""
    }`.trim();

    const tabs = [
      { title: "Leave Credits", content: <LeaveCredits object={object} /> },
      {
        title: "Leave Cards",
        content: (
          <LeaveCard object={object} object_ID={object.id} />
        ),
      },
    ];
    const tabContents = tabs.map((tab) => tab.content);

    return (
      <div className="overflow-auto px-5" style={{ marginTop: "5rem" }}>
        <CardView className="border-0">
            <div className="d-flex justify-content-between align-items-center px-5">
            <h4 className="text-primary mb-0">Leave Credits - {employeeName}</h4>
            <button
              type="button"
              className="btn btn-primary"
              onClick={this.onClickBack.bind(this)}
            >
              <i className="bi bi-arrow-left"> BACK</i> 
            </button>
            </div>

          <div className="row mt-3">
            <div style={{ width: "92%", margin: "auto" }}>
              <RegionTab tabs={tabs} tabContents={tabContents} />
            </div>
          </div>
        </CardView>
      </div>
    );
  }
}

export default withRouter(LeaveCreditsFormPage);
